import React from 'react';
import UserIcon from './UserIcon.svg';
import CheckmarkIcon from './CheckmarkIcon.svg';

const TaskBoxStatus = ({ icon, assignee }) => (
  <div className="layout-row layout-align-center-center flex-33">
    {assignee.firstName ? <CheckmarkIcon /> : <UserIcon />}

    <span className="pj-margin-left--narrow pj-font-family-thick">
      {assignee.firstName
        ? `Assigned to ${assignee.firstName} ${assignee.lastName || ''}`
        : 'Not assigned'}
    </span>
  </div>
);

export default TaskBoxStatus;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/components/TaskBoxStatus.jsx